// extracted by mini-css-extract-plugin
module.exports = {"tabs":"ExpensesPage_tabs__RQ08t"};